import { utils } from '@adc/ui-morpheus'
import { MAX_PERSONAL_SAVED_SEARCHES } from '../providers/savedSearches'

const { mapDispatchToSavedSearchActions } = utils.dispatchers

const SAVED_SEARCHES_LIMIT_MESSAGE =
  'You have reached the maximum number of saved searches. Please delete some before saving more.'

/**
 * Wraps mapDispatchToSavedSearchActions with a limit check on postSavedSearch.
 * When the user has reached MAX_PERSONAL_SAVED_SEARCHES personal saved searches,
 * the create is blocked and an error toast is shown via the datatable's built-in
 * notification system. Global searches do not count toward the limit.
 */
export const mapDispatchToSavedSearchActionsWithLimit = (
  dispatch,
  savedSearchActions,
  tableType
) => {
  const base = mapDispatchToSavedSearchActions(dispatch, savedSearchActions)

  return {
    ...base,
    postSavedSearch: (name, type) => {
      return dispatch((_, getState) => {
        const state = getState()
        const searches =
          (state[tableType] &&
            state[tableType].savedSearches &&
            state[tableType].savedSearches.searches) ||
          []
        const personalCount = searches.filter(
          s => s.saved_search_type === 'PERSONAL'
        ).length
        if (type !== 'GLOBAL' && personalCount >= MAX_PERSONAL_SAVED_SEARCHES) {
          dispatch({
            type: `FETCH_FAILURE_${tableType}_FOR_SAVED_SEARCHES`,
            status: 400,
            statusText: SAVED_SEARCHES_LIMIT_MESSAGE,
          })
          return Promise.resolve()
        }
        return dispatch(savedSearchActions.postSavedSearch(name, type))
      })
    },
  }
}
